import getQuestionBlock from "./getQuestionBlock";

const getFormControl = (questionCode) => {
  return getQuestionBlock(questionCode).find('.form-control');
};

export default getFormControl;
